export default __webpack_public_path__ + "static/media/nflStaff9.b87f3eca.jpg";